import React, { useContext, useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import MenuIcon from "../../components/icons/MenuIcon";
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  Typography,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";
import ListIcon from "../../components/icons/ListIcon";
import FilterIcon from "../../components/icons/FilterIcon";
import { getDataWithToken } from "../../services/GetDataService";
import { AuthContext } from "../../context/AuthContext";
import moment from "moment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Divider from "@mui/material/Divider";
import UserIcon from "../../components/icons/UserIcon";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles((theme) => ({
  card_holder: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "0px",
    gap: "16px",
    // margin: "60px 0",
    flexWrap: "wrap",
  },
  card1: {
    // background: theme.palette.paper.main,
    // padding: "24px",
    // borderRadius: "16px",
    boxSizing: "border-box",
    flex: "0 0 calc(50% - 8px)",
  },
}));

const UserDetails = ({ id }) => {
  const theme = useTheme();
  const classes = useStyles();
  // let { id } = useParams();
  const { login, admin_panel_user, logout } = useContext(AuthContext);
  const [userDetails, setUserDetails] = useState({});
  const [userBasicInfo, setUserBasicInfo] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [userMessage, setuserMessage] = useState("");

  const pageLoading = () => {
    let rows = [];

    for (let i = 0; i < 10; i++) {
      let cells = [];

      for (let j = 0; j < 8; j++) {
        cells.push(
          <TableCell key={j} sx={{ py: 1.5 }}>
            <Skeleton></Skeleton>
          </TableCell>
        );
      }

      rows.push(<TableRow key={i}>{cells}</TableRow>);
    }

    return rows;
  };

  const getData = async () => {
    setUserLoading(true);

    let users = await getDataWithToken(
      `getUserInformation?userId=${id}&storeId=${admin_panel_user.selectedStoreId}`,
      admin_panel_user,
      logout
    );

    if (users.data.status) {
      setUserDetails(users.data.data.userInfo);
      const basicInfo = [];

      for (const key in users.data.data.userInfo) {
        if (typeof users.data.data.userInfo[key] === "string") {
          const result = key.replace(/([A-Z])/g, " $1");
          const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
          basicInfo.push({
            key: finalResult,
            value: users.data.data.userInfo[key],
          });
        }
      }

      setUserBasicInfo(basicInfo);

      // } else {
      //   setuserMessage(users.data.message);
      // }
    } else {
      setuserMessage(users.data.message);
    }
    setUserLoading(false);
  };
  // 111
  // const [progress, setProgress] = React.useState(10);

  // React.useEffect(() => {
  //   const timer = setInterval(() => {
  //     setProgress((prevProgress) =>
  //       prevProgress >= 100 ? 0 : prevProgress + 10
  //     );
  //   }, 800);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);

  function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          variant="determinate"
          {...props}
          size="4.5rem"
          sx={{
            background:
              props.status === "error"
                ? theme.palette.error.light
                : theme.palette.success.light,
            borderRadius: "100vw",
          }}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="medium" component="div" color="text.secondary">
            {`${props.value}%`}
          </Typography>
        </Box>
      </Box>
    );
  }
  const showImageBox = () => {
    if (
      userDetails?.selfie_image?.selfie_image_link ||
      userDetails?.fail_photo_matching
    ) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    getData();

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [id]);
  return (
    <div>
      <Box className={classes.card_holder}>
        <Box className={classes.card1}>
          <Paper
            sx={{
              p: 3,
              height: "100%",
              boxShadow: "none",
              border: `1px solid ${theme.palette.border.main}`,
            }}
          >
            {" "}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ mb: 1.125 }}
            >
              <Grid item xs="auto">
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs="auto">
                    {" "}
                    <Avatar
                      sx={{
                        width: 44,
                        height: 44,
                        bgcolor: `${theme.palette.primary.light}`,
                      }}
                    >
                      <UserIcon color={theme.palette.primary.main} />
                    </Avatar>
                  </Grid>
                  <Grid item xs="auto">
                    <Typography
                      variant="base"
                      color="text.main"
                      sx={{ fontWeight: 500 }}
                    >
                      User basic information
                    </Typography>
                  </Grid>
                </Grid>{" "}
              </Grid>
              {/* <Grid item xs="auto">
                <IconButton>
                  <MenuIcon color={theme.palette.text.light} />
                </IconButton>
              </Grid> */}
            </Grid>
            <Divider sx={{ mb: 2 }} />
            {userLoading ? (
              <Grid container>
                <Grid item xs={6}>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    <Skeleton variant="rectangular" width="80%" />
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <Grid container>
                {userBasicInfo.length > 0 &&
                  userBasicInfo.map((row, i) => (
                    <Grid item xs={6}>
                      <Typography
                        variant="small"
                        color="text.main"
                        sx={{ mb: 2 }}
                      >
                        {row.key}: {row.value}
                      </Typography>
                    </Grid>
                  ))}
                {/* <Grid item xs={6}>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    Name: {userDetails.name}
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    ID: {userDetails.id ? userDetails.id : "-----"}
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    Doc ID: {userDetails.docId}
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    Dath of Birth: {userDetails.dob}
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    Gender: {userDetails.availableBalance}
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    Blood Group: {userDetails.bloodGroup}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    ID Type: {userDetails.idType}
                  </Typography>

                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    Country Name: {userDetails.countryName}
                  </Typography>

                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    Device: {userDetails.totalPending}
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    Issue Date: {userDetails.issueDate}
                  </Typography>
                  <Typography variant="small" color="text.main" sx={{ mb: 2 }}>
                    Expiry Date: {userDetails.expiryDate}
                  </Typography>
                </Grid> */}
              </Grid>
            )}
          </Paper>
        </Box>
        <Box className={classes.card1}>
          <Paper
            sx={{
              p: 3,
              height: "100%",
              boxShadow: "none",
              border: `1px solid ${theme.palette.border.main}`,
            }}
          >
            {" "}
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ mb: 1.125 }}
            >
              <Grid item xs="auto">
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs="auto">
                    {" "}
                    <Avatar
                      sx={{
                        width: 44,
                        height: 44,
                        bgcolor: `${theme.palette.primary.light}`,
                      }}
                    >
                      <UserIcon color={theme.palette.primary.main} />
                    </Avatar>
                  </Grid>
                  <Grid item xs="auto">
                    <Typography
                      variant="base"
                      color="text.main"
                      sx={{ fontWeight: 500 }}
                    >
                      National Identity Card
                    </Typography>
                  </Grid>
                </Grid>{" "}
              </Grid>
              {/* <Grid item xs="auto">
                <IconButton>
                  <MenuIcon color={theme.palette.text.light} />
                </IconButton>
              </Grid> */}
            </Grid>
            <Divider sx={{ mb: 2 }} />
            {userLoading ? (
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Skeleton
                    variant="rectangular"
                    height={220}
                    // sx={{ borderRadius: "24px" }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton
                    variant="rectangular"
                    height={220}
                    // sx={{ borderRadius: "24px" }}
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={2}>
                {userDetails?.front_side?.front_side_link && (
                  <Grid item xs="auto">
                    <Typography
                      variant="small"
                      color="text.main"
                      sx={{ mb: 1 }}
                    >
                      Front Side
                    </Typography>
                    <img
                      src={userDetails?.front_side?.front_side_link}
                      alt=""
                      style={{ maxWidth: "260px", maxHeight: "350px" }}
                    />
                  </Grid>
                )}
                {userDetails?.back_side?.back_side_link && (
                  <Grid item xs="auto">
                    <Typography
                      variant="small"
                      color="text.main"
                      sx={{ mb: 1 }}
                    >
                      Back Side
                    </Typography>
                    <img
                      src={userDetails?.back_side?.back_side_link}
                      alt=""
                      style={{ maxWidth: "260px", maxHeight: "350px" }}
                    />
                  </Grid>
                )}
              </Grid>
            )}
          </Paper>
        </Box>
        {/* {
          !userDetails?.selfie_image?.selfie_image_link &&
          userDetails?.fail_photo_matching?.length < 1 && ( */}
        {showImageBox() && (
          <Box className={classes.card1}>
            <Paper
              sx={{
                p: 3,
                height: "100%",
                boxShadow: "none",
                border: `1px solid ${theme.palette.border.main}`,
              }}
            >
              {" "}
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 1.125 }}
              >
                <Grid item xs="auto">
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item xs="auto">
                      {" "}
                      <Avatar
                        sx={{
                          width: 44,
                          height: 44,
                          bgcolor: `${theme.palette.primary.light}`,
                        }}
                      >
                        <UserIcon color={theme.palette.primary.main} />
                      </Avatar>
                    </Grid>
                    <Grid item xs="auto">
                      <Typography
                        variant="base"
                        color="text.main"
                        sx={{ fontWeight: 500 }}
                      >
                        {userDetails?.selfie_image?.selfie_image_link
                          ? "Selfie Images"
                          : "Unmatched Images"}
                      </Typography>
                    </Grid>
                  </Grid>{" "}
                </Grid>
                {/* <Grid item xs="auto">
                <IconButton>
                  <MenuIcon color={theme.palette.text.light} />
                </IconButton>
              </Grid> */}
              </Grid>
              <Divider sx={{ mb: 2 }} />
              {userLoading ? (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Skeleton
                      variant="rectangular"
                      height={220}
                      // sx={{ borderRadius: "24px" }}
                    />
                  </Grid>
                  {/* <Grid item xs={4}>
                  <Skeleton
                    variant="rectangular"
                    height={220}
                    // sx={{ borderRadius: "24px" }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton
                    variant="rectangular"
                    height={220}
                    // sx={{ borderRadius: "24px" }}
                  />
                </Grid> */}
                </Grid>
              ) : (
                <Grid container spacing={2}>
                  {/* {!userDetails?.optional_selfie_1?.selfie_image_1_link &&
                  !userDetails?.selfie_image?.selfie_image_link &&
                  !userDetails?.optional_selfie_2?.selfie_image_2_link && (
                    <>
                      <Grid item xs={12}>
                      <Typography
                        variant="h6"
                        color="text.main"
                        sx={{ my: 2, textAlign: "center" }}
                      >
                        No image available
                      </Typography>
                    </Grid>
                     
                    </>
                  )} */}
                  {!userDetails?.selfie_image?.selfie_image_link ? (
                    <Grid item xs={12}>
                      {userDetails?.fail_photo_matching?.map((item, i) => (
                        <Grid
                          key={i}
                          container
                          justifyContent="space-between"
                          alignItems="center"
                          sx={{ mb: 1 }}
                        >
                          <Grid item xs="auto">
                            <img
                              src={userDetails?.user_image?.user_image_link}
                              alt=""
                              style={{ maxWidth: "100%", maxHeight: "200px" }}
                            />
                          </Grid>
                          <Grid item xs="auto">
                            <Box sx={{ textAlign: "center" }}>
                              {item.matchPercent !== undefined && (
                                <CircularProgressWithLabel
                                  status="error"
                                  color="error"
                                  value={item.matchPercent.toFixed(2)}
                                />
                              )}
                            </Box>
                            <Typography
                              variant="h6"
                              color="error.main"
                              sx={{
                                textAlign: "center",
                                fontWeight: 500,
                              }}
                            >
                              Unmached
                            </Typography>
                          </Grid>
                          <Grid item xs="auto">
                            <img
                              src={item?.imageLink}
                              alt=""
                              style={{ maxWidth: "100%", maxHeight: "200px" }}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>
                  ) : (
                    <>
                      {userDetails?.selfie_image?.selfie_image_link && (
                        <Grid item xs={12}>
                          <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ mb: 1 }}
                          >
                            <Grid item xs="auto">
                              <img
                                src={userDetails?.user_image?.user_image_link}
                                alt=""
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "200px",
                                }}
                              />
                            </Grid>
                            <Grid item xs="auto">
                              <Box sx={{ textAlign: "center" }}>
                                <CircularProgressWithLabel
                                  status="success"
                                  color="success"
                                  value={
                                    userDetails?.matchPercent === undefined
                                      ? 90
                                      : userDetails?.matchPercent.toFixed(2)
                                  }
                                />
                              </Box>
                              <Typography
                                variant="h6"
                                color="success.main"
                                sx={{
                                  textAlign: "center",
                                  fontWeight: 500,
                                }}
                              >
                                Matched
                              </Typography>
                            </Grid>
                            <Grid item xs="auto">
                              <img
                                src={
                                  userDetails?.selfie_image?.selfie_image_link
                                }
                                alt=""
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "200px",
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </>
                  )}
                </Grid>
              )}
            </Paper>
          </Box>
        )}
        {/* ) } */}
      </Box>
    </div>
  );
};

export default UserDetails;
